"use strict";
module.exports = {
    projectName: 'CashAgad',
    country: 'Indonesia' // 国家（印尼 印度尼西亚）
};
